var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 6.392c-.042-.934-.192-1.567-.408-2.125a4.323 4.323 0 0 0-1.009-1.55 4.215 4.215 0 0 0-1.55-1.009c-.558-.216-1.191-.366-2.125-.408-.933-.042-1.233-.05-3.608-.05s-2.675.008-3.608.05c-.934.042-1.567.192-2.125.408a4.323 4.323 0 0 0-1.55 1.009 4.215 4.215 0 0 0-1.009 1.55c-.216.558-.366 1.191-.408 2.125-.042.933-.05 1.233-.05 3.608s.008 2.675.05 3.608c.042.934.192 1.567.408 2.125a4.323 4.323 0 0 0 1.009 1.55c.483.484.975.792 1.55 1.009.558.216 1.191.366 2.125.408.933.042 1.233.05 3.608.05s2.675-.008 3.608-.05c.934-.042 1.567-.192 2.125-.408a4.322 4.322 0 0 0 1.55-1.009 4.215 4.215 0 0 0 1.009-1.55c.216-.558.366-1.191.408-2.125.042-.933.05-1.233.05-3.608s0-2.675-.05-3.608Zm-1.575 7.141c-.042.859-.183 1.317-.3 1.625-.158.409-.35.7-.658 1.009-.309.308-.6.491-1.009.658-.308.117-.775.267-1.625.3-.916.042-1.2.05-3.533.05s-2.617-.008-3.533-.05c-.859-.042-1.317-.183-1.625-.3-.409-.158-.7-.35-1.009-.658a2.822 2.822 0 0 1-.658-1.009c-.117-.308-.267-.775-.3-1.625-.042-.925-.05-1.2-.05-3.541 0-2.342.008-2.617.05-3.542.042-.858.183-1.317.3-1.625.158-.408.35-.7.658-1.008.309-.309.6-.492 1.009-.659.308-.116.775-.266 1.625-.3.916-.041 1.2-.05 3.533-.05s2.617.009 3.533.05c.85.042 1.317.184 1.625.3.409.159.7.35 1.009.659.308.308.491.6.658 1.008.117.308.267.775.3 1.625.042.925.05 1.2.05 3.542 0 2.341-.017 2.616-.05 3.541Z",
    fill: "url(#instagram_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 0 0 0 9 4.5 4.5 0 0 0 0-9Zm0 7.417A2.92 2.92 0 0 1 7.083 10 2.92 2.92 0 0 1 10 7.083 2.92 2.92 0 0 1 12.917 10 2.92 2.92 0 0 1 10 12.917Z",
    fill: "url(#instagram_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.675 4.275c-.583 0-1.05.467-1.05 1.05s.467 1.05 1.05 1.05 1.05-.467 1.05-1.05-.467-1.05-1.05-1.05Z",
    fill: "url(#instagram_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__a",
    x1: 2.817,
    y1: 17.192,
    x2: 18.108,
    y2: 1.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D300C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7638FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__b",
    x1: 2.808,
    y1: 17.192,
    x2: 18.108,
    y2: 1.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D300C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7638FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__c",
    x1: 2.808,
    y1: 17.183,
    x2: 18.108,
    y2: 1.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D300C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7638FA"
  })))));
};
export default SvgInstagram;